import { Operation } from "@/Core/Client";
import { IsNullOrWhiteSpace } from "@/utils/Utils";
import isEqual from "lodash/isEqual";
import { useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

//TODO: proper typescript support fix
type State<T> = T & {
    reset?: T;
    sort?: string;
    page?: string | number;
    limit?: string | number;
};

export function useFilterWithBackend<StateType, _ActionType>(
    initialState: State<StateType>,
) {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();

    const createQueryString = useCallback(
        (name: string | string[], value: string | string[]) => {
            if (IsNullOrWhiteSpace(value)) return;
            const params = new URLSearchParams(searchParams.toString());

            console.log("--- name:", name, "value:", value);

            if (!Array.isArray(name)) {
                // rename if the key is exist in the search params by splitting the key . operator

                if (name === "sortDirection" && !params.has("sort")) return "";
                if (name === "sortDirection" && params.has("sort")) {
                    const [field, _isAscending] =
                        state["sort"]?.split(".") ?? [];

                    // console.log(
                    //     field,
                    //     "isAscending: ",
                    //     isAscending,
                    //     "value: ",
                    //     value,
                    // );

                    params.delete("sort");

                    params.set("sort", `${field}.${value}`);

                    return params.toString();
                }

                if (name == "sort") {
                    // const key = Array.from(params.keys()).find((k) => "sort");

                    if (params.has("sort")) {
                        const [_field, isAscending] =
                            state["sort"]?.split(".") ?? [];

                        // console.log(
                        //     field,
                        //     "isAscending: ",
                        //     isAscending,
                        //     "value: ",
                        //     value,
                        // );

                        params.delete("sort");

                        if (!IsNullOrWhiteSpace(isAscending))
                            params.set("sort", `${value}.${isAscending}`);
                        else params.set("sort", value.toString());

                        return params?.toString();
                    }

                    params.set(name, value?.toString());

                    return params.toString();
                }

                // console.log("-----0:", params.has(name));

                // find the by start with and delete it
                const _keys = Array.from(params.keys()).filter((k) =>
                    k.startsWith(name),
                )[0];

                if (name.includes(".") || _keys?.includes(".")) {
                    const [key, sign] = _keys?.split(".") ?? name.split(".");

                    // find the by start with and delete it
                    const keys = Array.from(params.keys()).filter((k) =>
                        k.startsWith(key),
                    );
                    // console.log("with . keys:", keys, key, sign);

                    keys.forEach((k) => params.delete(k));

                    params.set(`${key}.${sign}`, value?.toString());
                } else {
                    const keys = Array.from(params.keys()).filter((k) =>
                        k.startsWith(name),
                    );
                    // console.log("without . keys:", keys);

                    // delete
                    keys?.forEach((k) => params?.delete(k));

                    params.set(name, value.toString());
                }
            } else {
                name.forEach((n, idx) => {
                    params.set(n, value[idx]);

                    // find the by start with and delete it
                    const _keys = Array.from(params.keys()).filter((k) =>
                        k.startsWith(n),
                    )[0];

                    if (n.includes(".") || _keys?.includes(".")) {
                        const [key, sign] = _keys?.split(".") ?? n.split(".");

                        // find the by start with and delete it
                        const keys = Array.from(params.keys()).filter((k) =>
                            k.startsWith(key),
                        );
                        // console.log("with . keys:", keys, key, sign);

                        keys.forEach((k) => params.delete(k));

                        params.set(`${key}.${sign}`, value?.toString());
                    } else {
                        const keys = Array.from(params.keys()).filter((k) =>
                            k.startsWith(n),
                        );
                        // console.log("without . keys:", keys);

                        // delete
                        keys?.forEach((k) => params?.delete(k));

                        params.set(n, value.toString());
                    }
                });
            }

            return params.toString();
        },
        [searchParams],
    );

    const onSort = useCallback(
        (key: string) =>
            navigate(
                `${pathname}?${createQueryString(
                    ["sort", "page"],
                    [
                        isEqual(searchParams.get("sort"), key)
                            ? `-${key}`
                            : key,
                        "1",
                    ],
                )}
                `,
            ),
        [createQueryString, pathname, navigate, searchParams],
    );

    const parsedSearchParams = Object.fromEntries(searchParams);
    const state = {
        ...initialState,
        ...Object.fromEntries(
            Object.entries(parsedSearchParams).map(([k, v]) => {
                if (k.includes("date_range") || k.includes("_date")) {
                    return [k, v?.toString().split(";")];
                }
                return [k, v];
            }),
        ),
    };

    const params = Object.entries(parsedSearchParams).reduce(
        (acc, [k, v]) => ({ ...acc, ...getQueryParams(k, v) }),
        {},
    );

    const paginate = useCallback(
        (pageNumber: string | number) =>
            navigate(
                `${pathname}?${createQueryString("page", pageNumber.toString())}`,
            ),
        [createQueryString, pathname, navigate],
    );

    const applyFilter = useCallback(
        (key: string, payload: string | any[], operation?: Operation) => {
            // console.log("key:", key, "keyName:", keyName, "sign:", sign);

            if (key === "size") {
                const params = createQueryString(key, payload);

                return (
                    !IsNullOrWhiteSpace(params) &&
                    navigate(`${pathname}?${params}`)
                );
            }

            if (key === "sort" || key === "sortDirection") {
                const params = createQueryString(key, payload);

                return (
                    !IsNullOrWhiteSpace(params) &&
                    navigate(`${pathname}?${params}`)
                );
            }

            const [keyName, _sign] = key?.split(".");

            if (key.endsWith("operation")) {
                // find the key
                var keyValue =
                    state[keyName] ??
                    state[
                        Object.keys(state)
                            .find((k) => k.startsWith(keyName))
                            ?.valueOf() ?? ""
                    ];

                if (IsNullOrWhiteSpace(keyValue)) return;

                if (payload == Operation.in) {
                    return navigate(
                        `${pathname}?${createQueryString(
                            `${keyName}.${payload}`,
                            [keyValue],
                        )}`,
                    );
                } else
                    return navigate(
                        `${pathname}?${createQueryString(
                            `${keyName}.${payload}`,
                            keyValue,
                        )}`,
                    );
            }
            // if (key === "select") {
            //     return navigate(`${pathname}?${createQueryString("select", payload)}`);
            // }
            var params;

            if (operation) {
                params = createQueryString(`${keyName}.${operation}`, payload);
            } else params = createQueryString(keyName, payload);

            return (
                !IsNullOrWhiteSpace(params) && navigate(`${pathname}?${params}`)
            );
        },
        [createQueryString, pathname, navigate],
    );

    const getValue = (key: string) => {
        // key.forEach((item) => url.searchParams.delete(item));

        if (key === "sort") return state["sort"];

        // find the key by start with and return the value

        const keys = Array.from(searchParams.keys()).filter((k) =>
            k.startsWith(key),
        )[0];

        if (keys != undefined && keys) {
            // console.log(
            //     "keys:",
            //     keys,
            //     "state:",
            //     state[keys],
            //     "sp",
            //     state[keys.split(".")[0]],
            // );

            // if (keys.includes(".")) {
            //     return state[keys.split(".")[0]];
            // }

            return state[keys];
        }
    };

    const getOperator = (key: string) => {
        // key.forEach((item) => url.searchParams.delete(item));
        // find the key by start with and return the value
        const keys = Array.from(searchParams.keys()).filter((k) =>
            k.startsWith(key),
        )[0];

        // console.log("keys:", keys);

        if (!IsNullOrWhiteSpace(keys) && keys.includes(".")) {
            return keys.split(".")[1];
        }

        // return "";
    };

    const clearFilter = (key: string[]) => {
        let url = new URL(location.href);

        key.forEach((item) => url.searchParams.delete(item));

        navigate(`${pathname}${url.search}`);
    };

    const reset = useCallback(
        function setResetValue<T extends URLSearchParams>(resetValue?: T) {
            const params = new URLSearchParams(resetValue);
            return navigate(`${pathname}?${params.toString()}`);
        },
        [pathname, navigate],
    );

    return {
        params,
        state,
        onSort,
        paginate,
        applyFilter,
        clearFilter,
        reset,
        getValue,
        getOperator,
    };
}

function getQueryParams(key: string, payload: any) {
    if (key.includes("date_range") || key.includes("_date")) {
        const [start, end] = payload.split(";");
        if (start && end) {
            return { [`filter[${key}]`]: payload };
        }
        return {};
    }

    if (["page", "sort", "limit"].includes(key)) {
        return { [key]: payload };
    }
    return { [`filter[${key}]`]: payload };
}
